import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { parseLandingSectionId, scrollToLandingSection } from '../utils/landingSections'
import type { LandingSectionId } from '../utils/landingSections'

export function useLandingSectionNavigation() {
  const navigate = useNavigate()
  const location = useLocation()

  const goToSection = React.useCallback(
    (id: LandingSectionId) => {
      const isHome = location.pathname === '/'
      if (isHome) {
        scrollToLandingSection(id)
      } else {
        navigate(`/?section=${id}`)
      }
    },
    [location.pathname, navigate],
  )

  return { goToSection }
}

export function useLandingSectionOnLoad() {
  const location = useLocation()

  React.useEffect(() => {
    const params = new URLSearchParams(location.search)
    const fromQuery = parseLandingSectionId(params.get('section'))
    if (fromQuery) {
      scrollToLandingSection(fromQuery)
      return
    }

    if (location.hash && location.hash.length > 1) {
      const fromHash = parseLandingSectionId(location.hash.substring(1))
      if (fromHash) {
        scrollToLandingSection(fromHash)
      }
    }
  }, [location.search, location.hash])
}

